import { forwardRef, useEffect, useState } from 'react';

import { Container } from 'components/container';
import { Filter, FilterState, PersonType } from 'models';
import { useLocale } from 'locale';
import { useDataContext } from 'context/data-context';
//import { useAppContext } from 'context/app-context';
import { Filters } from './filters';
import { PeopleList } from './people-list';
import { Section, Title } from './styled';
import { filterPeople } from './helpers';

type Props = {
  person?: PersonType;
  title?: string;
};

export const VictimsList = forwardRef<HTMLDivElement, Props>(({ person, title }, ref) => {
  const [visibleFilter, setVisibleFilter] = useState<string>(person ? person.Judgement : '');
  const [activeFilter, setFilter] = useState<FilterState | null>(null);
  const [subfilters, setSubfilters] = useState<FilterState[]>([]);
  const locale = useLocale();
  const { people } = useDataContext();

  const filteredPeople = filterPeople(people, activeFilter, subfilters, person?.id);

  const handleFiterChange = (f: FilterState | null) => {
    if (activeFilter?.name !== f?.name) {
      setSubfilters([]);
    }

    setFilter(f);
    !f && setVisibleFilter('');
  };

  const handleSubfilterChange = (f: FilterState | null) => {
    setSubfilters((s) => {
      const changedFilterIndex = s.findIndex((x) => x.name === f?.name);

      if (changedFilterIndex < 0) return [...s, f as FilterState];

      return [
        ...s.slice(0, changedFilterIndex),
        ...(s[changedFilterIndex].value === f?.value ? [] : [f as FilterState]),
        ...s.slice(changedFilterIndex + 1),
      ];
    });
  };

  const handleToggle = (f: Filter) => {
    setVisibleFilter(f.value);

    if (f.value === activeFilter?.name && !person) {
      setFilter(null);
      setSubfilters([]);
      setVisibleFilter('');
    } else if (f.autoSelect && f.options?.length > 0 && !person) {
      handleFiterChange({
        name: f.value,
        value: f.options[0].value as string,
      });
    }
  };

  useEffect(() => {
    if (person) {
      setVisibleFilter('Judgement');
      setFilter({ name: 'Judgement', value: person.Judgement });
    }
  }, [person]);

  return (
    <Section ref={ref}>
      <Container>
        <Title>{title || (person ? locale.profile.relatedVictims : locale.home.listTitle)}</Title>

        <Filters
          visibleFilter={visibleFilter}
          activeFilter={activeFilter}
          activeSubfilters={subfilters}
          onChange={handleFiterChange}
          onSubfilterChange={handleSubfilterChange}
          onToggle={handleToggle}
          person={person}
        />

        <PeopleList filteredPeople={filteredPeople} />
      </Container>
    </Section>
  );
});
